import type { ReactNode } from 'react';

export const symbol_motion_photos_auto: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M415-427h131l28 74q2 7 7.5 10.5T594-339q12 0 19-9.5t2-20.5L509-647q-2-6-7.5-10t-12.5-4h-17q-7 0-12.5 3.5T452-647L346-368q-4 11 2.5 20t17.5 9q7 0 12.5-4t7.5-10l29-74Zm13-42 51-138h2l52 138H428Zm52 389q-83 0-156-31.5T197-197q-54-54-85.5-127T80-480q0-34 5.5-67t16.5-65q4-11 15-14.5t21 2.5q11 7 15.5 19t1.5 24q-6 25-10.5 50t-4.5 51q0 142 99 241t241 99q142 0 241-99t99-241q0-142-99-241t-241-99q-28 0-55 4t-53 12q-12 4-24-1t-17-16q-5-11 1-22t17-15q31-10 63-16t64-6q83 0 156.5 31.5T761-763q55 54 87 127t32 156q0 83-31.5 156T763-197q-54 54-127 85.5T480-80ZM177.5-713.5Q163-728 163-749t14.5-35.5Q192-799 213-799t35.5 14.5Q263-770 263-749t-14.5 35.5Q234-699 213-699t-35.5-14.5ZM480-480Z"
		/>
	</svg>
);
